import React from 'react';
import { Helmet } from 'react-helmet';

// Per-page SEO tags: unique title + description, self-referencing canonical
// (per host, so each regional subdomain canonicalizes to itself), optional noindex.
const Seo = ({ title, description, noindex }) => {
  const canonical = window.location.origin + window.location.pathname;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default Seo;
